export const isAffiliate = (c) => c?.kind === "affiliate";

export function safeUrl(u) {
  if (!u) return "";
  const v = /^https?:\/\//i.test(u) ? u : `https://${u}`;
  try {
    const url = new URL(v);
    return url.protocol === "http:" || url.protocol === "https:" ? url.href : "";
  } catch { return ""; }
}

const fmt = (d) => {
  if (!d) return "";
  const [y, m, day] = d.split("-");
  return y && m && day ? `${Number(day)}.${Number(m)}.${y}` : d;
};

export function affiliateValidity(c) {
  if (c.start_date && c.end_date) return `${fmt(c.start_date)} – ${fmt(c.end_date)}`;
  if (c.start_date) return `Alkaen ${fmt(c.start_date)}, toistaiseksi`;
  if (c.end_date) return `Voimassa ${fmt(c.end_date)} asti`;
  return "Toistaiseksi voimassa";
}

export const formatCommission = (v) => `${String(v ?? "").replace(".", ",")} %`;

export const COMMISSION_HELP = "Provisio on sisällöntuottajalle kuuluva osuus hyväksytystä myynnistä. Myynnin seurannasta ja provision maksamisesta sovitaan yrityksen kanssa – Creatori ei seuraa myyntejä eikä maksa provisioita.";

const THEMES = {
  pink: {
    card: "!border-[#F8D3E1] !bg-gradient-to-b from-[#FDE8F0] to-[#FFF6F9]",
    strip: "bg-[#FBE0EA]", accentText: "text-[#E2457F]", icon: "bg-[#E2457F] text-white",
    badge: "bg-[#E2457F] text-white", button: "bg-[#EC5A93] text-white group-hover:bg-[#E2457F] hover:bg-[#E2457F]",
    soft: "bg-[#FDE8F0]",
  },
};

export const affiliateTheme = () => THEMES.pink;

export const joinType = (c) => (c.join_mode === "external" ? "external" : c.who_can_join === "all" ? "direct" : "apply");
